import { Trans } from "react-i18next";
import "./QuotationOrderedBanner.css";
import { Message } from "primereact/message";

export const QuotationOrderedBanner = () => {
    return (
        <div className="px-3">
            <Message
                className="w-full"
                severity="info"
                text={
                    <Trans
                        i18nKey={"quotations.ordered.description"}
                        components={[
                            <a
                                content="Mail link for Idwal Enquiries"
                                className="summary-link"
                                key="contact-us"
                                href="mailto:enquiries@idwalmarine.com"
                            />
                        ]}
                    />
                }
            />
        </div>
    );
};
